import GoogleMap from '../../lib/GoogleMaps/Map';
import throttle from '../../lib/utils/events/throttle';
import '../../lib/GoogleMaps/InfoBox';
import InfoBoxInterface from '../../lib/GoogleMaps/InfoBox';

const CLASS_LOCATION_CURRENT: string = 'current';
const MARKERS_SIZE: number = 60;

// const currentElementCollection: {[index: string]: Fields} = Object.create( null );
const currentElementCollection: {[index: string]: HTMLElement} = Object.create( null );

export default function init(): void
{
	var map: GoogleMap;
	var mapElement: HTMLElement;
	var options: {center: number[]; zoom: number};
	const styles: any = [
		{
			"featureType": "all",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"gamma": 0.5
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		}
	];
	
	mapElement = <HTMLElement>document.querySelector( 'div[data-map]' );
	
	if ( !mapElement )
	{
		return;
	}
	options = JSON.parse( mapElement.dataset['map'] );

	if ( !options.center )
	{
		return;
	}
	
	map = new GoogleMap(
		mapElement,
		() => ({
			// координаты офиса
			// center: new google.maps.LatLng(59.941998, 30.256874),
			// координаты порта
			center: new google.maps.LatLng(59.903194, 30.234266),
			zoom: 14,
			scrollwheel: false,
			streetViewControl: false,
			panControl: false,
			zoomControl: false,
			disableDoubleClickZoom: false,
			mapTypeControl: false,
			navigationControl: false,
			overviewMapControl: false,
			rotateControl: false,
			scaleControl: false
		}),
		() => {
			var infoBox: InfoBoxInterface;

			infoBox = GoogleMap.plugin<InfoBoxInterface>( 'InfoBox', 'Test info box' );
			infoBox.sayHello();
			map.map.setOptions({styles: styles});
			mapInitialized( map );
		}
	);
	
	window.addEventListener(
		'resize',
		throttle(
			() =>
			{
				map.resize();
			}
		)
	);
}

function mapInitialized( map: GoogleMap ): void
{
	const container: HTMLElement = document.querySelector( 'main>div.tabs-places' ) as HTMLElement;
	const streets: NodeList = container.querySelectorAll( 'ul.places>li>a' );
	const currentElements: NodeList = container.querySelectorAll( 'ul>li.current' );
	
	addGroundOverlay( map );
	
	Array.prototype.forEach.call(
		currentElements,
		( item: HTMLElement ) =>
		{
			currentElementCollection[item.dataset['name']] = item;
		}
	);
	
	Array.prototype.forEach.call (
		streets,
		( element: HTMLAnchorElement ) =>
		{
			var coordinates: google.maps.LatLng;

			coordinates = getCoordinates( element.href );

			element.addEventListener('click', ( event: Event ) => jump( event, element, coordinates, map ));

			marker( map, coordinates, element.textContent );
		}
	);
}

function getCoordinates( uri: string ): google.maps.LatLng
{
	var pattern: RegExp;
	var matches: RegExpMatchArray;

	pattern = /@([\d.]+),([\d.]+),/;
	matches = uri.match( pattern );

	if ( matches )
	{
		return new google.maps.LatLng(
			Number( matches[1] ),
			Number( matches[2] )
		);
	}
	else
	{
		return null;
	}
}

function jump( event: Event, element: HTMLElement, coordinates: google.maps.LatLng, map: GoogleMap )
{
	event.preventDefault();
	
	if ( !element.parentElement.classList.contains( CLASS_LOCATION_CURRENT ) )
	{
		currentElementCollection['place'].classList.remove( CLASS_LOCATION_CURRENT );
		delete currentElementCollection['place'];
		map.map.panTo( coordinates );
		
		element.parentElement.classList.add( CLASS_LOCATION_CURRENT );
		currentElementCollection['place'] = element.parentElement;
	}
}

function marker( map: GoogleMap, coordinates: google.maps.LatLng, title: string )
{
	var marker: google.maps.Marker;
	
	marker = new google.maps.Marker(
		{
			position: coordinates,
			map: map.map,
			icon: {
				url: '/images/map/marker.png',
				size: new google.maps.Size( MARKERS_SIZE, MARKERS_SIZE ),
				origin: new google.maps.Point( 0, 0 ),
				anchor: new google.maps.Point( 20, 52 )
			},
			clickable: true,
			title: title
		}
	);
}

function addGroundOverlay( map: GoogleMap ): void {
	var imageBounds: google.maps.LatLngBounds;
	var image: string = '/images/map/port_shape.svg';
	
	imageBounds = new google.maps.LatLngBounds(
		new google.maps.LatLng( 59.902109, 30.230866 ),
		new google.maps.LatLng( 59.903526, 30.234948 )
	);

	new google.maps.GroundOverlay(
		image,
		imageBounds,
		{
			clickable: false,
			map: map.map
		}
	);
}
